import { Link } from '@tanstack/react-router';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import type { ArticleCardData } from './ArticleCard';
import { SmartImage } from '../../../components/media/SmartImage';

export function NationalSection({ items }: { items: ArticleCardData[] }) {
  if (items.length === 0) return null;
  return (
    <section className="feature-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title">
              <h3 className="title">أخبار وطنية</h3>
            </div>
          </div>
        </div>
        <Swiper
          modules={[Navigation, Autoplay]}
          dir="rtl"
          navigation
          slidesPerView={4}
          spaceBetween={30}
          loop={items.length > 4}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
          }}
          className="feature-post-slider"
        >
          {items.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="feature-post">
                <div className="feature-post-thumb">
                  <Link to="/articles/$slug" params={{ slug: item.slug }}>
                    <SmartImage media={item.coverMedia} alt={item.title} />
                  </Link>
                </div>
                <div className="feature-post-content">
                  <div className="post-meta" />
                  <h4 className="title">
                    <Link to="/articles/$slug" params={{ slug: item.slug }}>
                      {item.title}
                    </Link>
                  </h4>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
